import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '../../../Skeleton';
import { SelectMenuContext } from '../../context';
import { FolderSelectionList } from '../../FolderSelectionList';
import { SelectMenuTypes } from '../../helper';
import { MultiSelectionList } from '../../MultiSelectionList';
import { SingleSelectionList } from '../../SingleSelectionList';
import SkeletonLoader from '../../UI/Skeleton/SkeletonLoader';
import styles from '@dtsl/css-select-menu/dist/index.module.css';
import AlertTriangle from '@dtsl/icons/dist/icons/react/AlertTriangle';
function SelectMenuComponent(props) {
  const {
    selectMenuType = 'singleSelection',
    isLoading = false,
    options = [],
    noOptionContent = /*#__PURE__*/React.createElement("div", {
      className: styles['sib-selectmenu-no-option__content']
    }, /*#__PURE__*/React.createElement(Skeleton, {
      height: 60,
      width: "50%"
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['sib-selectmenu-no-option-wrapper']
    }, /*#__PURE__*/React.createElement("div", null, "Oops, there are no items in the list yet"), /*#__PURE__*/React.createElement("div", {
      className: styles['sib-selectmenu-no-option-subtext']
    }, /*#__PURE__*/React.createElement(AlertTriangle, null), " you should provide a solution."))),
    isCreateBtnPresent = false,
    tabMetaData = [],
    activeTabIndex = 0
  } = props;
  const {
    tabsLoading
  } = useContext(SelectMenuContext);
  function getComponent() {
    /** If there are tabs currently loading and the active tab's
     * metadata exists and matches the loading tabs, show a SkeletonLoader */
    if (tabsLoading.length > 0 && tabMetaData[activeTabIndex] && tabsLoading.includes(tabMetaData[activeTabIndex]?.id)) {
      return /*#__PURE__*/React.createElement(SkeletonLoader, null);
    }
    switch (selectMenuType) {
      case SelectMenuTypes.SINGLE_SELECTION:
        return /*#__PURE__*/React.createElement(SingleSelectionList, props);
      case SelectMenuTypes.MULTI_SELECTION:
        return /*#__PURE__*/React.createElement(MultiSelectionList, props);
      case SelectMenuTypes.FOLDER_SINGLE_SELECTION:
        return /*#__PURE__*/React.createElement(FolderSelectionList, props);
      case SelectMenuTypes.FOLDER_MULTI_SELECTION:
        return /*#__PURE__*/React.createElement(FolderSelectionList, props);
      default:
        return null;
    }
  }
  return isLoading ? /*#__PURE__*/React.createElement(SkeletonLoader, null) : options.length > 0 ? getComponent() : /*#__PURE__*/React.createElement("ul", {
    className: `${styles['sib-selectmenu-options']} ${options.length === 0 && isCreateBtnPresent ? styles['sib-selectmenu-options__no-padding'] : ''}`,
    role: "presentation"
  }, /*#__PURE__*/React.createElement("li", {
    className: `${styles['sib-selectmenu-option']} ${styles['sib-selectmenu-no_option']}`,
    role: "option",
    tabIndex: "0",
    "aria-selected": "false"
  }, noOptionContent));
}
SelectMenuComponent.propTypes = {
  isCreateBtnPresent: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSubFolder: PropTypes.bool,
  selectMenuType: PropTypes.string,
  noOptionContent: PropTypes.node,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    value: PropTypes.any,
    icon: PropTypes.func,
    helpText: PropTypes.string,
    addtionalInfo: PropTypes.func,
    customLabelStyle: PropTypes.object
  })),
  tabMetaData: PropTypes.array,
  activeTabIndex: PropTypes.number
};
export default SelectMenuComponent;